/* istanbul ignore file */
export const isOnline = /*@__PURE__*/ (() => typeof navigator === 'undefined' || !('onLine' in navigator) ?
    () => true
    : () => navigator.onLine)();
//# sourceMappingURL=isOnline.js.map